import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Crown, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

export function UpgradeBanner() {
  return (
    <Card className="bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200 mb-6 shadow-sm">
      <CardContent className="p-6 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-amber-100 rounded-full shrink-0">
            <Crown className="h-6 w-6 text-amber-600" />
          </div>
          <div className="text-center md:text-left">
            <h3 className="font-semibold text-lg text-amber-900">Unlock Full Potential</h3>
            <p className="text-amber-700">
              Upgrade to Pro for increased asset limits, advanced analytics, and priority support.
            </p>
          </div>
        </div>
        <Button asChild className="bg-amber-600 hover:bg-amber-700 text-white border-none shadow-md shrink-0 w-full md:w-auto">
          <Link to="/app/settings">
            <Sparkles className="mr-2 h-4 w-4" />
            Upgrade to Pro
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
